import { lazy } from 'react';
const Home = lazy(() => import('@pages/home/Home'));
const homeRoute =  [
    {
        path: "/",
        name: '首页',
        component: Home
    }
]
export default homeRoute